import React from 'react';
import { Provider } from 'react-redux';
import { store } from "../store";
import { CacheProvider } from "@emotion/react";
import { ChakraProvider } from "@chakra-ui/react";
import { theme } from "../theme";
import createCache from "@emotion/cache";
import { createRoot } from "react-dom/client";
import { AlertContainer } from "./alert-container";
class AlertContainerWebComponent extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        var _a;
        const documentId = parseInt((_a = this.getAttribute("data-document-id")) !== null && _a !== void 0 ? _a : "1");
        const shadowRoot = this.attachShadow({ mode: "open" });
        const root = document.createElement("div");
        shadowRoot.appendChild(root);
        const cache = createCache({
            container: shadowRoot,
            key: "c"
        });
        const reactDom = createRoot(root);
        reactDom.render(React.createElement(Provider, { store: store },
            React.createElement(CacheProvider, { value: cache },
                React.createElement(ChakraProvider, { theme: theme },
                    React.createElement(AlertContainer, { documentId: documentId })))));
    }
}
if (!customElements.get('alert-container')) {
    customElements.define('alert-container', AlertContainerWebComponent);
}
